<template>
  <div class="home">
    <div>
      <!-- <a-carousel style="position: relative;">
                <div v-for="x in item_lunbo" class="banner-lunbo">
                    <img :src="x.image" alt=""  style="object-fit: cover;" >
                </div>
            </a-carousel> -->
      <div class="banner-center ">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide class="banner">
            <div class="banner-title">
              <h3>易知鸟教培机构运营管理系统</h3>
              <h4>30000+教培机构的共同选择</h4>
            </div>
            <div class="banner-info ">
              <div class="btn shenqing" @click="openDialog('免费试用', 0)">
                申请试用
              </div>
            </div>
          </swiper-slide>
          <!-- <swiper-slide class="banner banner3">
            <div class="banner-title">
              <h3>双十一特惠早鸟礼 超值福利专场</h3>
              <h4>活动名额仅限99名 ，送完即止</h4>
              <h5>赠送时长 电子合同 京东购物卡</h5>
              <h5>小票打印机 商城购物卡 收银小白盒</h5>
              <h5>学员作品集 校长课门票 线下辅导</h5>
            </div>
            <div class="banner-info " style="bottom:80px;">
              <div class="btn shenqing" @click="openServer()">
                点击了解
              </div>
            </div>
          </swiper-slide> -->
          <swiper-slide class="banner banner1">
            <div class="banner-title">
              <h3>素质类教培机构专属运营管理系统</h3>
              <h4>舞蹈 · 美术 · 音乐 · 体育 · 科技 · 口才</h4>
              <h4>围棋 · 书法 · 模特 · 跆拳道</h4>
            </div>
            <div class="banner-info ">
              <div class="btn shenqing" @click="openDialog('免费试用', 0)">
                申请试用
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="banner banner2">
            <div class="banner-title">
              <h3>素质类教培机构一站式数字化解决方案</h3>
              <h4>招生营销 教务管理 智能排课</h4>
              <h4>日常课务 刷脸消课 线上课程</h4>
              <h4>老生续费 线上缴费 在线商城</h4>
              <h4>电子合同 家校服务 财务统计</h4>
            </div>
            <div class="banner-info " style="bottom:50px;">
              <div class="btn shenqing" @click="openDialog('免费试用', 0)">
                申请试用
              </div>
            </div>
          </swiper-slide>

          <!-- <swiper-slide
            v-for="(item, index) in bannerList"
            :key="index"
            style="margin-top:80px"
          >
            <img
              :src="item"
              width="100%"
              height="480px"
              alt=""
              @click="openDialog('免费试用', 0)"
            />
          </swiper-slide> -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="item_1 bgfff center">
      <div class="item-title">
        <h4 class="title1">全方位解决</h4>
        <h3 class="title2">教培机构5大运营管理难题</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents">
        <ul>
          <li v-for="(x, key) in item1_list" :key="key">
            <img :src="x.img_" alt="" />
            <div class="title">{{ x.title }}</div>
            <div class="content">{{ x.value }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="home_video">
      <div class="center home_video_img">
        <div class="item-title">
          <h3 class="title2" style="margin-bottom:10px">
            你就是下一位智慧校长
          </h3>
          <div class="video_tip">(点击观看易知鸟产品宣传片)</div>
        </div>
        <div
          class="video_father"
          @mouseenter="videoIsShow = true"
          @mouseleave="videoIsShow = false"
        >
          <video
            src="https://cdn.yizhiniao.com/yizhiniao_xuanchuanpian_20230802.mp4"
            ref="video"
            width="100%"
            height="100%"
            controls
            poster="https://cdntest.yizhiniao.com/newWebsite_/home/vbg_2.png"
          ></video>
          <div class="video_own_play" v-show="videoIsShow">
            <img :src="videoImg" @click="playVideo(false)" alt="play" />
          </div>
        </div>
      </div>
    </div>
    <div class="item_2" ref="houme_video_trailer">
      <div class="center">
        <div class="item-title">
          <h4 class="title1">10大产品亮点</h4>
          <h3 class="title2">提升教培机构综合竞争力</h3>
          <div class="marker"></div>
        </div>
        <div class="item-contents">
          <ul>
            <li
              v-for="(x, index) in item2_1_list"
              @mouseenter="hoveritem(x, index)"
              @mouseleave="x.hover = false"
              :key="index"
            >
              <img :src="x.img_" alt="" v-show="!x.hover" />
              <p v-show="x.hover">{{ x.info }}</p>
              <div class="title">{{ x.title }}</div>
            </li>
          </ul>
          <ul>
            <li
              v-for="(x, index) in item2_2_list"
              @mouseenter="hoveritem(x, index)"
              @mouseleave="x.hover = false"
              :key="index"
            >
              <img :src="x.img_" alt="" v-show="!x.hover" />
              <p v-show="x.hover">{{ x.info }}</p>
              <div class="title">{{ x.title }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="item_3 bgfff center">
      <div class="item-title">
        <h4 class="title1">6大增值服务</h4>
        <h3 class="title2">为教培机构保驾护航</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents">
        <ul>
          <li
            v-for="(x, index) in item3_list"
            :class="{ active: itemsHover.ind == index }"
            @mouseenter="hovernav(x, index)"
            :key="index"
          >
            <img :src="x.navImg" alt="" />
            <div class="title">{{ x.title }}</div>
          </li>
        </ul>
        <div class="item-info">
          <div class="item-info-left fl">
            <h5>{{ itemsHover.title }}</h5>
            <h6>{{ itemsHover.info }}</h6>
            <div class="btn shenqing" @click="openDialog('免费试用', 0)">
              申请试用
            </div>
          </div>
          <div class="item-img fl">
            <img :src="itemsHover.image" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="item_4 bgfff" ref="home_video_comment">
      <div class="item-title">
        <h4 class="title1">易知鸟运营管理系统</h4>
        <h3 class="title2">
          <span class="number">30000+</span>教培机构共同的选择
        </h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li
            v-for="(x, index) in item4.arr"
            :class="[{ jqhover: x.hover_ }]"
            @mouseenter="x.hover_ = true"
            @mouseleave="leaveItem4()"
            :key="index"
          >
            <div class="tap">我们都在用</div>
            <!-- <li v-for="(x,index) in item4_list" :class="[{'jqhover':x.hover_}]" @mouseenter="x.hover_ = true" @mouseleave="leaveItem4()"> -->
            <div class="logo">
              <img :src="x.logo" alt="" width="100%" />
            </div>
            <div class="title">{{ x.person }}</div>
            <div class="info">
              <p>“{{ x.info }}”</p>
              <span>——{{ x.person }}</span>
            </div>
          </li>
        </ul>
        <div class="btn shenqing" @click="changeJigou()">换一批看看</div>
      </div>
    </div>

    <div class="home_video_two">
      <div class="center video_two_main">
        <div
          class="video_father_two"
          @mouseenter="videoIsShow1 = true"
          @mouseleave="videoIsShow1 = false"
        >
          <video
            src="https://cdn.yizhiniao.com/yizhiniao_laoshihaoping.mp4"
            poster="https://cdntest.yizhiniao.com/newWebsite_/home/vbg_1.png"
            ref="video1"
            width="100%"
            height="100%"
            controls
          ></video>
          <div class="video_own_play" v-show="videoIsShow1">
            <img :src="videoImg1" @click="playVideo(true)" alt="play" />
          </div>
        </div>
        <div class="item-title video_two_right">
          <h4 class="video_two_title">他们都在用易知鸟</h4>
          <div class="video_tip mb10">“校长真实使用反馈与好评</div>
          <div class="video_tip">
            &nbsp;&nbsp;&nbsp;全国30000+智慧校长的共同选择！”
          </div>
        </div>
      </div>
    </div>

    <lun-bo></lun-bo>
    <div class="item_6">
      <div class="item-title">
        <h3 class="title2 fz40">行业资讯</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <div class="clearfix">
          <div
            class="left-img"
            :style="{
              backgroundImage: 'url(' + item6Hover.bigImg + ')',
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat'
            }"
          >
            <div class="news">
              <div class="news-title">{{ item6Hover.title }}</div>
              <div class="news-info">{{ item6Hover.introduction }}</div>
            </div>
          </div>
          <div class="right-info">
            <ul>
              <li
                v-for="(x, index) in item6"
                @mouseenter="hover6(x)"
                @click="toNewsDetail(x)"
                :key="index"
              >
                <div class="title clearfix">
                  <div class="img"></div>
                  <h5 class="fz22">{{ x.title }}</h5>
                </div>
                <p>{{ x.introduction }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="lookmore">
          <a
            href="javascript:void(0)"
            v-if="item6.length > 4"
            @click="goLookmore()"
            >查看更多></a
          >
        </div>
      </div>
    </div>
    <div class="item_7">
      <div class="item-title">
        <h3 class="title2 fz40">填写表单，免费试用</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li class="input-li">
            <span class="input-name school">机构名称：</span>
            <div class="input-ctrl">
              <input
                type="text"
                placeholder="请在这里填写您的机构名称"
                v-model="shenqing.shopName"
              />
            </div>
          </li>
          <li class="input-li">
            <span class="input-name name"
              >姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span
            >
            <div class="input-ctrl">
              <input
                type="text"
                placeholder="请在这里填写您的姓名"
                v-model="shenqing.name"
              />
            </div>
          </li>
          <li class="input-li">
            <span class="input-name phone">手&nbsp;机&nbsp;号：</span>
            <div class="input-ctrl">
              <input
                type="text"
                placeholder="请在这里填写您的手机号码"
                v-model="shenqing.phone"
                maxlength="11"
                @input="checkValidPhone()"
              />
            </div>
          </li>
          <li class="input-li">
            <span class="input-name code">验&nbsp;证&nbsp;码：</span>
            <div class="input-ctrl code">
              <input
                type="text"
                placeholder="请在这里填写您的验证码"
                v-model="shenqing.testCode"
              />
              <div
                class="test"
                :class="{ active: checkValidPhone() }"
                @click="getTestcode()"
              >
                {{ shenqing.codeText }}
              </div>
            </div>
          </li>
          <li class="input-li error" v-if="shenqing.errText">
            {{ shenqing.errText }}
          </li>
          <li class="input-li success" v-if="shenqing.successText">
            {{ shenqing.successText }}
          </li>
        </ul>
        <div class="btn shenqing bgRed submit" @click="submitBtn()">提交</div>
      </div>
      <div class="item-footer"></div>
    </div>
  </div>
</template>

<script>
import lunBo from "./lunbo.vue";
import CONFIG from "../../config/config";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    lunBo,
    swiper,
    swiperSlide
  },
  data() {
    return {
      bannerList: ["static/img/home/2.png", "static/img/home/1.png"],
      swiperOption: {
        autoplay: true,
        speed: 2000,
        loop: true,
        pagination: {
          el: ".swiper-pagination", //分页器
          clickable: true
        }
      },
      videoIsShow: true,
      videoIsShow1: true,
      videoImg: "https://cdntest.yizhiniao.com/newWebsite_/home/play.png",
      videoImg1: "https://cdntest.yizhiniao.com/newWebsite_/home/play.png",
      item6Hover: {},
      isDuringTime: false,
      timerHandler: undefined,
      shenqing: {
        count: 60,
        codeText: "发送验证码",
        successText: "",
        errText: "",
        shopName: "",
        name: "",
        phone: "",
        testCode: ""
      },
      item4: { num: 0, arr: [] },
      item_lunbo: [
        { image: "https://cdntest.yizhiniao.com/newWebsite_/home/banner.png" },
        {
          image:
            "https://cdntest.yizhiniao.com/newWebsite_/product_face/chanpin5_banner.png"
        },
        {
          image:
            "https://cdntest.yizhiniao.com/newWebsite_/product_jiaopei/chanpin1_banner.png"
        }
      ],
      itemsHover: {
        title: "数据安全",
        navImg: "static/img/home/item3_1.png",
        image: "static/img/home/item3_hover1.png",
        info: "银行级数据安全保障",
        ind: 0
      },
      item1_list: [
        {
          title: "招生引流难",
          value: "招生推广方式单一，人力财力投入大，成本高、转化低",
          img_: "static/img/home/item1_1.png"
        },
        {
          title: "资金漏洞多",
          value: "收支明细、人员工资、财税等数据杂乱，查账对账费时费力",
          img_: "static/img/home/item1_2.png"
        },
        {
          title: "教务管理混乱",
          value: "教学、管理、考评等效果无法量化，资源利用不充分",
          img_: "static/img/home/item1_3.png"
        },
        {
          title: "家校沟通频次低",
          value: "家校沟通缺乏系统性平台辅助，家长参与度低，满意度差",
          img_: "static/img/home/item1_4.png"
        },
        {
          title: "决策分析无依据",
          value: "缺乏资金、收支、课消等数据统计与分析，决策无数据支持",
          img_: "static/img/home/item1_5.png"
        }
      ],
      item2_1_list: [
        {
          title: "精准营销",
          info: "线上+线下全渠道裂变传播，精准招生",
          img_: "static/img/home/item2_1_1.png"
        },
        {
          title: "在线缴费",
          info: "学员线上缴费，支持信用卡、花呗等付款方式",
          img_: "static/img/home/item2_1_2.png"
        },
        {
          title: "智能排课",
          info: "智能可视化排课，资源高效利用",
          img_: "static/img/home/item2_1_3.png"
        },
        {
          title: "刷脸消课",
          info: "人脸识别签到，支持自动点名消课",
          img_: "static/img/home/item2_1_4.png"
        },
        {
          title: "提高续费",
          info: "围绕学员全学习周期，续费率显著提升",
          img_: "static/img/home/item2_1_5.png"
        }
      ],
      item2_2_list: [
        {
          title: "家校互通",
          info: "建立家校信息沟通平台，沟通更顺畅",
          img_: "static/img/home/item2_2_1.png"
        },
        {
          title: "数据统计",
          info: "自动生成多维度数据图表，决策有依据",
          img_: "static/img/home/item2_2_2.png"
        },
        {
          title: "在线商城",
          info: "机构在线销售课程，实现线上营销",
          img_: "static/img/home/item2_2_3.png"
        },
        {
          title: "线上课程",
          info: "线下课程线上化，助力机构线上教学 ",
          img_: "static/img/home/item2_2_4.png"
        },
        {
          title: "分销体系",
          info: "活动一键分销裂变，触达精准目标客群",
          img_: "static/img/home/item2_2_5.png"
        }
      ],
      item3_list: [
        {
          title: "数据安全",
          navImg: "static/img/home/item3_1.png",
          image: "static/img/home/item3_hover1.png",
          info: "银行级数据安全保障"
        },
        {
          title: "7*24h在线",
          navImg: "static/img/home/item3_2.png",
          image: "static/img/home/item3_hover2.png",
          info: "客服7*24h快速响应"
        },
        {
          title: "免费升级",
          navImg: "static/img/home/item3_3.png",
          image: "static/img/home/item3_hover3.png",
          info: "系统每周免费自动升级"
        },
        {
          title: "定期回访",
          navImg: "static/img/home/item3_4.png",
          image: "static/img/home/item3_hover4.png",
          info: "提高客户使用满意度"
        },
        {
          title: "1v1指导",
          navImg: "static/img/home/item3_5.png",
          image: "static/img/home/item3_hover5.png",
          info: "一对一在线指导操作"
        },
        {
          title: "臻享服务",
          navImg: "static/img/home/item3_6.png",
          image: "static/img/home/item3_hover6.png",
          info: "专业领域缔造专业服务"
        }
      ],
      item4_list_0: [
        {
          person: "小天鹅创始人 胡雪",
          logo: "static/img/common/logo/lang/1.png",
          info:
            "易知鸟的可贵之处在于，功能上十分丰富，而在操作上又十分简洁。人性化的产品交互逻辑，可以帮助行政人员大大提升工作效率。易知鸟系统满足了机构转型升级的需求，将成为机构实现数字化、信息化的有力工具。"
        },
        {
          person: "宁方舞蹈创始人 张丁方",
          logo: "static/img/common/logo/lang/2.png",
          info:
            "易知鸟的统计分析功能为我们直观展示了机构的销售、教务、财务等数据，为我们做决策提供了强大的数据支持，帮助我们做出更清晰准确的决策。"
        },
        {
          person: "小童星创始人 潘丽群",
          logo: "static/img/common/logo/lang/3.png",
          info:
            "易知鸟对于教育机构的认知和我们比较吻合，所以在产品功能、落地使用场景等方面和我们很契合，特别是在跨校区管理方面，很有想法，又很落地，引领我们提高跨校区管理水平。"
        }
      ],
      item4_list_1: [
        {
          person: "葛道围棋创始人 葛玉宏",
          logo: "static/img/common/logo/lang/4.png",
          info:
            "使用易知鸟系统以来，机构在招生、教务、课务、行政管理等方面都得到了极大改善，老师们在手机上就可以完成很多工作，很实用，孩子们和家长对机构的满意度达到95%。"
        },
        {
          person: "天鹅国际副总裁 杨小峰",
          logo: "static/img/common/logo/lang/5.png",
          info:
            "易知鸟为机构和家长建立起了沟通桥梁，我们与家长、学员无缝连接，拉近了我们和家长之间的距离，更精准地把握学员学习动向，从而更好地帮助学员成长，机构的续费率提升了30%。"
        },
        {
          person: "口才宝杭州总校长 赵李",
          logo: "static/img/common/logo/lang/6.png",
          info:
            "我们使用易知鸟系统三年了，易知鸟的功能操作简单易学，老师们用了之后纷纷表示很实用，我们在3天内完成了1000+学员的续费、缴费、登记、收据打印、发放全过程，大大提升了工作效率。"
        }
      ],
      item4_list_2: [
        {
          person: "舞维一体创始人 舒俊",
          logo: "static/img/common/logo/lang/7.png",
          info:
            "数字化、信息化是机构的未来趋势，易知鸟系统满足了我们对机构转型升级的需求，为我们的5家直营店、29家加盟店以及数万名学员提供了专业的系统服务，全面提升了我们的竞争力。"
        },
        {
          person: "中邮艺术团创始人 胡宇",
          logo: "static/img/common/logo/lang/8.png",
          info:
            "易知鸟是专注为校外培训机构量身打造的教务管理系统，因为更懂机构，所以对提升机构运营管理效率、加快实现规范化教学有非常大的帮助。"
        },
        {
          person: "舞动七彩光创始人 付付",
          logo: "static/img/common/logo/lang/9.png",
          info:
            "用易知鸟系统三年了，不仅提升了我们的招生、教务、家校沟通等能力，还为我们提供了不少优质教育资源，慢慢成了我们的“左膀右臂”。接下来，我们会继续选择易知鸟，我相信在教育这条路上，有易知鸟的支持，舞动七彩光一定会发展得更好。"
        }
      ],

      item6: [
        { title: "教育产业迎来新时代" },
        { title: "易知鸟管理系统全新升级2.0版本" },
        { title: "小学生最喜欢哪些兴趣教育" },
        { title: "易知鸟感恩节活动" }
      ],
      pauseUrl: "https://cdntest.yizhiniao.com/newWebsite_/home/pause.png",
      playUrl: "https://cdntest.yizhiniao.com/newWebsite_/home/play.png"
    };
  },
  created() {
    this.item2_1_list.map((item, i) => {
      this.$set(item, "hover", false);
    });
    this.item2_2_list.map((item, i) => {
      this.$set(item, "hover", false);
    });
    this.item4_list_0.map((item, i) => {
      this.$set(item, "hover_", false);
    });
    this.item4.arr = this.item4_list_0;
  },
  mounted() {
    this.getList();
    let videoOne = this.$refs.video,
      videoTwo = this.$refs.video1;
    this.listenerVideo(videoOne, false);
    this.listenerVideo(videoTwo, true);
    this.listenerPlay(videoOne, false);
    this.listenerPlay(videoTwo, true);
    this.listenerPause(videoOne, false);
    this.listenerPause(videoTwo, true);

    // window.onscroll = ()=> {
    //     //为了保证兼容性，这里取两个值，哪个有值取哪一个
    //     //scrollTop就是触发滚轮事件时滚轮的高度
    //     let topTrailer = this.$refs.houme_video_trailer.offsetTop
    //     let topComment = this.$refs.home_video_comment.offsetTop
    //     let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //     console.log(topTrailer)
    //     console.log(scrollTop)
    //     if(scrollTop == topTrailer){
    //        this.playMeth(false)
    //     }else if(topComment == scrollTop){
    //        this.playMeth(true)
    //     }
    // }
  },
  beforeDestroy() {
    this.destroyedPause();
  },
  methods: {
    openServer() {
      window.open(
        "https://affim.baidu.com/unique_26793823/chat?siteId=12817462&userId=26793823&siteToken=8276cb3b89a1a0af9977363c735736f1"
      );
    },
    changeVideoIcon(obj) {
      let { ele, type, val = undefined } = { ...obj };
      if (!ele.paused) {
        this.psuseMeth(type);
      } else {
        this.playMeth(type);
      }
      if (val) {
        if (type) {
          this.$refs.video.pause();
        } else {
          this.$refs.video1.pause();
        }
      }
    },
    listenerPlay(ele, type) {
      ele.addEventListener("play", () => {
        //  console.log("播放")
        this.changeVideoIcon({ ele, type, val: true });
      });
    },
    listenerPause(ele, type) {
      ele.addEventListener("pause", () => {
        //  console.log("暂停")
        this.changeVideoIcon({ ele, type });
      });
    },
    listenerVideo(ele, type) {
      ele.addEventListener("ended", () => {
        this.playMeth(type);
      });
    },

    destroyedPause() {
      let videoOne = this.$refs.video,
        videoTwo = this.$refs.video1;
      if (!videoOne.paused) {
        videoOne.pause();
      }
      if (!videoTwo.paused) {
        videoTwo.pause();
      }
    },
    videoBg(type, key) {
      if (type) {
        this.videoImg1 = key ? this.playUrl : this.pauseUrl;
      } else {
        this.videoImg = key ? this.playUrl : this.pauseUrl;
      }
    },
    playMeth(type) {
      if (type) {
        this.videoIsShow1 = true;
        this.videoBg(true, true);
      } else {
        this.videoIsShow = true;
        this.videoBg(false, true);
      }
    },
    psuseMeth(type) {
      if (type) {
        this.videoIsShow1 = true;
        this.videoBg(true, false);
      } else {
        this.videoIsShow = true;
        this.videoBg(false, false);
      }
    },
    playVideo(type) {
      let video = type ? this.$refs.video1 : this.$refs.video;
      if (type) {
        this.$refs.video.pause();
        this.videoBg(false, true);
      } else {
        this.$refs.video1.pause();
        this.videoBg(true, true);
      }

      if (video.paused) {
        video.play();
        this.psuseMeth(type);
      } else {
        video.pause();
        this.playMeth(type);
      }
    },
    onChange(a, b, c) {
      console.log(a, b, c);
    },
    hoveritem(x, ind) {
      x.hover = true;
    },
    hovernav(x, ind) {
      this.itemsHover = {
        title: x.title,
        info: x.info,
        image: x.image,
        ind: ind
      };
    },
    hover6(x) {
      this.item6Hover = x;
    },
    leaveItem4() {
      this.item4.arr.map((item, i) => {
        item.hover_ = false;
      });
    },
    changeJigou() {
      this.item4.num++;
      if (this.item4.num == 1) {
        this.item4.arr = this.item4_list_1;
      } else if (this.item4.num == 2) {
        this.item4.arr = this.item4_list_2;
      } else {
        this.item4.arr = this.item4_list_0;
        this.item4.num = 0;
      }
      this.item4.arr.map((item, i) => {
        this.$set(item, "hover_", false);
      });
      console.log(this.item4);
    },
    openDialog: function(title, type) {
      //type:(0机构,1微官网)
      this.$parent.$refs.openPop.openDialog(title, type);
    },
    checkValidPhone() {
      if (!(this.shenqing.phone && /^1\d{10}$/.test(this.shenqing.phone))) {
        return false;
      }
      return true;
    },
    goLookmore() {
      this.$router.push({
        path: "/aboutUs_news",
        query: {
          fromId: "6",
          parentId: "6_0"
        }
      });
      var query = this.$route.query;
      localStorage.setItem("current", JSON.stringify(query));
    },
    getTestcode() {
      var this_ = this;
      if (!this_.checkValidPhone()) {
        return (this_.shenqing.errText = "请输入正确的手机号");
      }
      //设置button效果，开始计时
      if (this_.isDuringTime) {
        return;
      }

      //向后台发送处理数据
      var param = {
        phone: this.shenqing.phone
      };
      $.ajax({
        url: this_.CONFIG.URL + "/api/oa/sms/getAuthCode",
        type: "get",
        data: param,
        success: function(data) {
          this_.$nextTick(() => {
            if (data.status == "200") {
              this_.shenqing.codeText = this_.shenqing.count + "s后重发";
              this_.timerHandler = setInterval(
                function() {
                  if (this_.shenqing.count <= 0) {
                    clearInterval(this_.timerHandler);
                    this_.shenqing.count = 60;
                    this_.shenqing.codeText = "发送验证码";
                    this_.isDuringTime = false;
                    return;
                  } else {
                    this_.shenqing.count--;
                    this_.shenqing.codeText = this_.shenqing.count + "s后重发";
                    this_.isDuringTime = true;
                  }
                },
                1000,
                100
              );
            } else {
              this_.shenqing.errText = data.message;
            }
          });
        },
        error: function(data) {
          this_.$nextTick(() => {
            this_.shenqing.errText = "网络异常,请稍后再试";
          });
        }
      });
    },
    submitBtn() {
      var this_ = this;
      // if (!this_.shenqing.shopName) {
      //     return this.shenqing.errText = "请输入机构名称";
      // }
      // if (!this_.shenqing.name) {
      //     return this.shenqing.errText = "请输入机构联系人";
      // }
      if (!(this_.shenqing.phone && this_.checkValidPhone())) {
        return (this.shenqing.errText = "请输入正确手机号码");
      }
      if (!this_.shenqing.testCode) {
        return (this.shenqing.errText = "请输入验证码");
      }
      var data = {
        visitorShopName: this_.shenqing.shopName,
        visitorName: this_.shenqing.name,
        visitorType: "0", //0机构1微官网
        visitorPhone: this_.shenqing.phone,
        code: this_.shenqing.testCode
      };
      $.ajax({
        url: this_.CONFIG.URL + "/api/admin/visitor/add",
        type: "post",
        data: JSON.stringify(data),
        async: false,
        contentType: "application/json;charset=UTF-8",
        success: function(data) {
          this_.$nextTick(() => {
            if (data.status == "200") {
              clearInterval(this_.timerHandler); //停止计时器
              this_.isDuringTime = false;
              this_.timerHandler = undefined;
              this_.shenqing = {
                count: 60,
                codeText: "发送验证码",
                errText: "",
                successText: data.message
                // shopName:"",
                // name:"",
                // phone:"",
                // testCode:""
              };
            } else {
              this_.shenqing.errText = data.message;
            }
          });
        },
        error: function(data) {
          this_.$nextTick(() => {
            this_.shenqing.errText = "网络异常,请稍后再试";
          });
        }
      });
    },
    getList() {
      var this_ = this;
      $.ajax({
        url: this_.CONFIG.URL + "/api/admin/contents/list",
        type: "get",
        data: { start: 0, count: 10 },
        success: function(data) {
          this_.$nextTick(() => {
            if (data.status == "200") {
              this_.item6 = data.context.items;
              if (data.context && this_.item6.length > 0) {
                this_.item6Hover = this_.item6[0];
              }
            }
          });
        },
        error: function(data) {
          this_.$nextTick(() => {
            this_.$notification["error"]({
              message: "提示",
              description: "网络异常,请稍后再试",
              style: {
                position: "fixed",
                top: "50%",
                left: "50%"
              }
            });
          });
        }
      });
    },
    toNewsDetail(x) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          contentsId: x.contentsId
        }
      });
      localStorage.setItem("contentsId", this.$route.query.contentsId);
    }
  }
};
</script>

<style scoped lang="less">
h3 {
  margin-top: 16px;
}
/deep/.swiper-pagination-bullet {
  width: 20px;
  height: 3px;
  border-radius: 3.5px;
  background: #fff;
}
/deep/.swiper-pagination-bullet-active {
  background: rgba(250, 112, 117, 0.5);
}

/* /deep/.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

/deep/.ant-carousel  .slick-slide h3 {
  color: #fff;
} */

.banner,
.banner1,
.banner2,
.banner3 {
  width: 100%;
  height: 480px;
  margin-top: 80px;
  overflow: hidden;
  position: relative;
  background: url("https://cdntest.yizhiniao.com/newWebsite_/home/banner.jpg")
    no-repeat center;
  .banner-center {
    height: 100%;
    position: relative;
  }
  .banner-title {
    position: absolute;
    top: 80px;
    left: 60px;
    h3 {
      font-size: 42px;
      line-height: 59px;
      text-align: left;
      color: #fff;
      margin: 0;
    }
    h4 {
      margin-top: 15px;
      font-size: 26px;
      line-height: 37px;
      text-align: left;
      color: #fff;
    }
    h5 {
      font-size: 17px;
      line-height: 20px;
      text-align: left;
      color: #fff;
      font-weight: 400;
    }
  }
  .banner-info {
    position: absolute;
    bottom: 120px;
    left: 60px;
    text-align: left;
  }
}
.banner1 {
  background: url("https://cdntest.yizhiniao.com/newWebsite_/home/item1_banner1.png")
    no-repeat center;
  .btn {
    color: #4ab5ff;
    border: 2px solid #4ab5ff;
  }
  .btn:hover {
    background: #4ab5ff;
    color: #fff;
  }
}
.banner2 {
  background: url("https://cdntest.yizhiniao.com/newWebsite_/home/item1_banner2.png")
    no-repeat center;
  .btn {
    color: #ff941c;
    border: 2px solid #ff941c;
  }
  .btn:hover {
    background: #ff941c;
    color: #fff;
  }
}
.banner3 {
  background: url("https://cdntest.yizhiniao.com/newWebsite_/home/item1_banner3.png")
    no-repeat center;
  .btn {
    color: #f25f44;
    border: 2px solid #ff8066;
  }
  .btn:hover {
    background: #ff8066;
    color: #fff;
  }
}
.item_1 {
  padding: 120px 20px 160px;

  .item-contents {
    margin-top: 60px;

    ul {
      display: flex;
      justify-content: space-between;

      li {
        width: 200px;
        height: 340px;
        padding: 20px 0;
        background: #ffffff;
        box-shadow: 0px 0px 40px 0px #f1f1f1;

        img {
          width: 120px;
          height: 120px;
          margin: 0 auto 7px;
        }

        .title {
          text-align: center;
          color: #4a4a4a;
          font-size: 22px;
        }

        .content {
          width: 120px;
          margin: 13px auto 0;
          color: #9b9b9b;
          font-size: 16px;
          text-align: left;
          line-height: 22px;
        }

        &:hover {
          .content {
            color: #4a4a4a;
          }

          transition: 0.5s;
          margin-top: -10px;
          box-shadow: 0px 8px 30px 0px #e1e5ea;
        }
      }
    }
  }
}
.video_own_play1 {
  .video_own_play {
    width: 100px;
    height: 100px;
    position: absolute;
    top: calc(50% - 50px);
    left: 0px;
    right: 0px;
    margin-left: auto;
    margin-right: auto;
    // background: rgba(0, 0, 0, 0.4);
    img {
      width: 100%;
      height: 100%;
      // margin: 0 auto;
      // position: relative;
      // top: calc(50% - 50px);
    }
  }
}
.home_video {
  width: 100%;
  // height: 580px;
  margin: 180px auto;
  margin-top: 0;
  .home_video_img {
    background: url(https://cdntest.yizhiniao.com/newWebsite_/home/video_bg.png)
      no-repeat center;
    background-size: 100% 50%;
    background-position: bottom;
    width: 1200px;
  }
  .video_tip {
    font-size: 22px;
    color: #9b9b9b;
  }
  .video_father {
    width: 800px;
    height: 450px;
    margin: 0 auto;
    position: relative;
    margin-top: 80px;
    .video_own_play1();
  }
}
.home_video_two {
  margin-bottom: 180px;
  .video_two_main {
    display: flex;
    align-items: flex-start;
    // justify-content: center;
    .video_two_right {
      margin: 28px 0 10px 160px;
      position: relative;
      .video_tip {
        font-size: 16px;
        color: #1e1e1e;
        text-align: left;
      }
      &::before {
        content: "";
        display: inline-block;
        width: 57px;
        height: 49px;
        background: url(https://cdntest.yizhiniao.com/newWebsite_/home/yleft.png)
          no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: -29px;
        left: -19px;
      }
      &::after {
        content: "";
        display: inline-block;
        width: 57px;
        height: 49px;
        background: url(https://cdntest.yizhiniao.com/newWebsite_/home/yright.png)
          no-repeat;
        background-size: 100% 100%;
        position: absolute;
        bottom: -45px;
        right: -24px;
      }
    }
    .video_father_two {
      width: 451px;
      height: 338px;
      position: relative;
      margin-left: 30px;
      .video_own_play1();
    }
  }
}
.item_2 {
  width: 100%;
  height: 810px;
  background: url("https://cdntest.yizhiniao.com/newWebsite_/home/item2_bg.jpg")
    no-repeat center;
  padding: 80px 0 100px;

  .item-title {
    h4,
    h3 {
      color: #fff;
    }
  }

  .item-contents {
    margin-top: 92px;
    padding: 0 18px;
    color: #fff;

    ul {
      display: flex;
      justify-content: space-between;

      li {
        width: 230px;
        height: 200px;

        img {
          width: 120px;
          height: 120px;
          margin: 0 auto 10px;
        }

        .title {
          text-align: center;
          font-size: 22px;
          line-height: 30px;
          color: #fff;
        }

        p {
          font-size: 16px;
          padding: 0 15px;
          margin-top: 53px;
          line-height: 22px;
          text-align: left;
          margin-bottom: 34px;
        }

        &:hover {
          border: 1px solid #ffffff;
        }
      }
    }

    ul:nth-child(1) {
      margin-bottom: 30px;
    }
  }
}

.item_3 {
  padding: 180px 0 150px;

  .item-contents {
    margin-top: 84px;

    ul {
      display: flex;
      justify-content: space-between;
      padding: 0 80px;

      li {
        width: 112px;
        /* height: 110px; */

        img {
          width: 110px;
          height: 60px;
          margin: 0 auto 10px;
        }

        .title {
          text-align: center;
          color: #646464;
          font-size: 22px;
        }

        &.active {
          .title {
            position: relative;
            color: #1e1e1e;
            font-size: 22px;
            line-height: 30px;
            padding-bottom: 18px;

            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 4px;
              background: #1e1e1e;
              border-radius: 4px;
            }
          }
        }
      }
    }

    .item-info {
      padding: 0 0 0 80px;
      margin-top: 30px;

      .item-info-left {
        margin-right: 70px;
        padding-top: 162px;
      }

      h5 {
        font-size: 30px;
        line-height: 42px;
        color: #000;
        text-align: left;
      }

      h6 {
        font-size: 16px;
        line-height: 22px;
        color: #4b4b4b;
        text-align: left;
        margin-top: 4px;
      }

      .btn {
        margin-top: 46px;
      }

      .item-img {
        width: 850px;
        height: 450px;
      }
    }
  }
}

.item_4 {
  .item-title {
    width: 100%;
    height: 356px;
    padding-top: 170px;
    background: url("https://cdntest.yizhiniao.com/newWebsite_/common/tiao1_bg.png")
      no-repeat center;

    .number {
      font-size: 60px;
      font-family: WenYue-XinQingNianTi-NC-W8, WenYue-XinQingNianTi-NC;
      font-weight: normal;
      color: #ff3c4f;
      line-height: 74px;
    }
  }

  .item-contents {
    padding: 90px 50px 160px;

    ul {
      display: flex;
      flex-wrap: nowrap;

      li {
        float: left;
        width: 340px;
        height: 300px;
        background: #ffffff;
        box-shadow: 0px 0px 40px 0px #f1f1f1;
        border-radius: 8px;
        position: relative;
        padding: 60px 30px 40px;

        .tap {
          display: none;
          width: 185px;
          height: 69px;
          background: url("https://cdntest.yizhiniao.com/newWebsite_/home/tap.png")
            no-repeat center;
          position: absolute;
          top: -87px;
          left: 22%;
          line-height: 53px;
          font-size: 24px;
          color: #1e1e1e;
        }

        &.jqhover {
          padding: 20px;
          box-shadow: 6px 6px 40px 0px #e3e3e3;

          .title {
            display: none;
          }

          .logo {
            display: none;
          }

          .info {
            display: block;
            position: relative;
            height: 100%;
          }

          span {
            position: absolute;
            bottom: 0;
            right: 0;
          }

          .tap {
            display: block;
          }
        }

        &:not(:last-child) {
          margin-right: 40px;
        }

        .logo {
          max-width: 280px;
          max-height: 150px;
          margin: 0 auto;
          display: block;
        }

        .info {
          display: none;
        }

        .title {
          font-size: 20px;
          font-weight: 600;
          color: #1e1e1e;
          line-height: 28px;
          width: calc(100% - 30px);
          text-align: center;
          position: absolute;
          bottom: 40px;
        }

        .info p {
          text-align: left;
          font-size: 16px;
          line-height: 30px;
          color: #1e1e1e;
        }

        .info span {
          text-align: right;
        }
      }
    }

    .shenqing {
      margin: 60px auto 0;
    }
  }
}

.item_6 {
  padding-top: 180px;

  .item-contents {
    padding: 80px 20px 150px;

    .lookmore {
      width: 100%;
      text-align: center;
      margin: 20px auto 0;

      a {
        color: #ff3c4f;
        font-size: 18px;
        line-height: 25px;
      }
    }

    .left-img {
      float: left;
      width: 580px;
      height: 350px;
      /* border: 1px solid; */
      position: relative;
      overflow: hidden;
      .news {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 580px;
        height: 80px;
        background: rgba(0, 0, 0, 0.5);
        padding: 5px 20px 9px;
        color: #fff;
        text-align: left;

        .news-title {
          text-align: left;
          font-size: 26px;
          line-height: 37px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .news-info {
          text-align: left;
          font-size: 18px;
          line-height: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .right-info {
      width: 560px;
      height: 350px;
      margin-left: 20px;
      float: left;
      overflow: hidden;
      li {
        width: 560px;
        height: 80px;
        padding: 10px 12px;
        cursor: pointer;

        .img {
          float: left;
          width: 26px;
          height: 26px;
          margin-right: 8px;
          background: url("https://cdntest.yizhiniao.com/newWebsite_/home/new_hover.png")
            no-repeat center;
        }

        h5 {
          font-size: 22px;
          line-height: 30px;
          color: #1e1e1e;
          float: left;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 500px;
        }

        p {
          font-size: 18px;
          line-height: 25px;
          color: #9b9b9b;
          text-align: left;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        &:hover {
          background-color: #f8f8f8;

          p {
            color: #1e1e1e;
          }

          img {
            background: url("https://cdntest.yizhiniao.com/newWebsite_/home/new.png")
              no-repeat center;
          }
        }

        &:not(:first-child) {
          margin-top: 10px;
        }
      }
    }
  }
}

.item_7 {
  .item-title {
    padding: 170px 0 116px;
    background: url("https://cdntest.yizhiniao.com/newWebsite_/common/tiao1_bg.png")
      no-repeat center;
  }

  .item-footer {
    width: 100%;
    height: 180px;
    background: url("https://cdntest.yizhiniao.com/newWebsite_/common/tiao2_bg.png")
      no-repeat top;
  }

  .item-contents {
    ul {
      margin: 0 auto;
      width: 900px;
    }

    .input-li {
      clear: both;
      overflow: hidden;

      &.error {
        color: #fa7074;
        font-size: 24px;
      }

      &.success {
        font-size: 24px;
        animation: success_text 2s ease-in;
      }

      @keyframes success_text {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }

      &:not(:first-child) {
        margin-top: 50px;
      }

      span {
        position: relative;
        float: left;
        width: 135px;
        padding-left: 46px;
        height: 50px;
        display: inline-block;
        line-height: 50px;
        text-align: left;

        &:before {
          content: "";
          position: absolute;
          bottom: 15px;
          left: 0;
          width: 32px;
          height: 32px;
        }

        &.school:before {
          background: url("https://cdntest.yizhiniao.com/newWebsite_/home/school.png")
            no-repeat center;
        }

        &.name:before {
          background: url("https://cdntest.yizhiniao.com/newWebsite_/home/name.png")
            no-repeat center;
        }

        &.phone:before {
          background: url("https://cdntest.yizhiniao.com/newWebsite_/home/phone.png")
            no-repeat center;
        }

        &.code:before {
          background: url("https://cdntest.yizhiniao.com/newWebsite_/home/code.png")
            no-repeat center;
        }
      }

      .input-ctrl {
        float: left;
        width: 680px;
      }

      .input-ctrl input {
        width: 680px;
        height: 50px;
        background: #fafafa;
        border-radius: 4px;
        border: 2px solid #ececec;
        padding: 14px 20px;
        text-align: left;
      }

      .input-ctrl.code input {
        width: 480px;
        display: inline-block;
        float: left;
      }

      .input-ctrl.code .test {
        display: inline-block;
        float: right;
        width: 180px;
        height: 50px;
        border-radius: 4px;
        border: 2px solid #e3e3e3;
        color: #e3e3e3;
        font-size: 22px;
        line-height: 25px;
        padding: 10px 33px;
        text-align: center;
        cursor: pointer;
      }

      .input-ctrl.code .test.active {
        color: #fa7074;
        border: 2px solid #fa7074;
        background: #fff;

        &:hover {
          color: #fff;
          border: none;
          background: #ffabad;
        }

        &:active {
          border: none;
          background: #ff3c4f;
        }
      }
    }

    .submit {
      margin: 70px auto 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue